import styles from "./ViewToggle.module.css";

const ViewToggle = ({ view, onViewChange }) => {
  return (
    <div className={styles.viewToggle} role="group" aria-label="View toggle">
      <button
        type="button"
        className={`${styles.toggleButton} ${view === 'grid' ? styles.active : ''}`}
        onClick={() => onViewChange('grid')}
        aria-pressed={view === 'grid'}
        aria-label="Grid view"
        title="Grid view"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="3" width="8" height="8" strokeWidth="2" strokeLinejoin="round" />
          <rect x="13" y="3" width="8" height="8" strokeWidth="2" strokeLinejoin="round" />
          <rect x="3" y="13" width="8" height="8" strokeWidth="2" strokeLinejoin="round" />
          <rect x="13" y="13" width="8" height="8" strokeWidth="2" strokeLinejoin="round" />
        </svg>
      </button>
      <button
        type="button"
        className={`${styles.toggleButton} ${view === 'list' ? styles.active : ''}`}
        onClick={() => onViewChange('list')}
        aria-pressed={view === 'list'}
        aria-label="List view"
        title="List view"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
          <line x1="3" y1="6" x2="21" y2="6" strokeWidth="2" strokeLinecap="round" />
          <line x1="3" y1="12" x2="21" y2="12" strokeWidth="2" strokeLinecap="round" />
          <line x1="3" y1="18" x2="21" y2="18" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </button>
    </div>
  );
};

export default ViewToggle;
